function checkType( type ){

    const listIcon = [
        {
            type: "reject_sp",
            icon: "fa-exclamation-triangle text-red"
        },
        {
            type: "reject_sa",
            icon: "fa-exclamation-triangle text-orange"
        },
        {
            type: "waiting_sa",
            icon: "fa-paper-plane text-orange"
        },
        {
            type: "waiting_sp",
            icon: "fa-paper-plane text-blue"
        },
        {
            type: "wait_doc",
            icon: "fa-file-import text-yellow"
        },
        {
            type: "success",
            icon: "fa-check-circle text-green"
        }
    ]

    let result = listIcon.find((icon) => {
        return icon.type == type
    })
    
    if( typeof result === 'undefined' ){

        return 'fa-envelope text-blue'
    }


    return result.icon
}

export default checkType